module.exports = __webpack_public_path__ + "static/img/img_logo.959d4ab2.png";